import { lembrarTipoTotem } from "@/constants/types/tipoTotem";

export default {
  setToken(state, payload) {
    state.token = payload;
  },
  setTotemFranqueadoId(state, franqueadoID) {
    state.totem.franqueadoId = franqueadoID;
  },
  setTotem(state, payload) {
    state.totem = payload;
    // O tipo decide o layout da Home; guardado para o próximo boot já montar
    // a tela certa, antes do primeiro snapshot do totem chegar.
    if (payload && payload.id) lembrarTipoTotem(payload.tipoTotem);
  },
  setError(state, payload) {
    state.erros.push(payload);
  },
  removeErrors(state) {
    state.erros = [];
  },
  setAFK(state, payload) {
    state.afk = payload;
  },
};
